import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import AuthLayout from "@/layouts/AuthLayout.vue";
import LoginView from "../views/auth/LoginView.vue";
import NotFound from "@/views/errors/NotFound.vue";
import Forbidden from "@/views/errors/Forbidden.vue";
import Users from "@/views/users/Users.vue";
import Distributors from "@/views/distributors/Distributors.vue";
import Clients from "@/views/clients/Clients.vue";
import Dashboard from "@/views/dashboard/Dashboard.vue";
import { useAuthStore } from "@/stores/auth.store";
import { UserRole } from "@/enums/user-role.enum";
import { hasAccess } from "@/utils/role-hierarchy";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "AuthLayout",
    component: AuthLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: "",
        name: "Dashboard",
        component: Dashboard,
        meta: {
          requiresAuth: true,
          titleKey: "nav.dashboard"
        }
      },
      {
        path: "users",
        name: "Users",
        component: Users,
        meta: {
          requiresAuth: true,
          requiresRole: UserRole.SuperAdmin,
          titleKey: "nav.users"
        }
      },
      {
        path: "distributors",
        name: "Distributors",
        component: Distributors,
        meta: {
          requiresAuth: true,
          requiresRole: UserRole.SuperAdmin,
          titleKey: "nav.distributors"
        }
      },
      {
        path: "clients",
        name: "Clients",
        component: Clients,
        meta: {
          requiresAuth: true,
          requiresRole: UserRole.Distributor,
          titleKey: "nav.clients"
        }
      }
    ]
  },
  {
    path: "/auth/login",
    name: "LoginPanel",
    component: LoginView
  },
  {
    path: "/forbidden",
    name: "Forbidden",
    component: Forbidden
  }, // Trasa dla 403
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: NotFound
  }, // Obsługa błędu 404
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const authStore = useAuthStore(); // Pobieramy store z Pinia
  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    // Jeśli strona wymaga logowania, a użytkownik nie jest zalogowany → przekierowanie do loginu
    return next({ name: "LoginPanel" });
  }
  else if (to.meta.requiresRole) {
    const userRole = authStore.user?.role;
    const requiredRole = to.meta.requiresRole as UserRole;
    if (!userRole || !hasAccess(userRole, requiredRole)) {
      return next({ name: "Forbidden" });
    }
  }
  next(); // Wpuszczamy użytkownika
});

export default router;
